/**
 * Centralized i18n message descriptors for the FOMO nudge.
 *
 * Both products consume defineMessages output via formatMessage:
 *   - Confluence: `react-intl`
 *   - Jira: `@atlassian/jira-intl`
 *
 * Keeping copy here ensures parity across products. Phase 1 is an empty
 * placeholder so the file exists without pulling in `react-intl` yet.
 */

import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	fomoNudgeTitle: {
		id: 'rovo-fomo-nudge.title',
		defaultMessage: 'Your teammates are chatting with Rovo',
		description: 'Title for the FOMO nudge shown to non-Rovo-MAU users on launch day.',
	},
	fomoNudgeDescription: {
		id: 'rovo-fomo-nudge.description',
		defaultMessage: 'Try chat today to get quick answers and draft work fast.',
		description: 'Subtitle for the FOMO nudge.',
	},
	fomoNudgeIconLabel: {
		id: 'rovo-fomo-nudge.icon-label',
		defaultMessage: 'Avatars of your collaborators using Rovo',
		description: 'Accessible label for the avatar-stack icon on the FOMO nudge.',
	},
});
